import EvidenceChipRow from './EvidenceChipRow';

export default EvidenceChipRow;

export type { IEvidenceChipRowProps } from './EvidenceChipRow';
